<template>
    <q-list class="q-mb-md">
        <q-collapsible icon="fal fa-filter" v-model="open" @click="toggle" :label="getNameFilter">
            <div class="row gutter-sm" v-if="options">

                <div class="col-xs-12 col-sm-12" v-if="options.company_types && options.company_types.length">
                    <q-select filter autofocus-filter v-model="filters.company_type" chips :options="options.company_types" multiple :float-label="$t('company_type')" clearable />
                </div>

                <div class="col-xs-12 col-sm-12" v-if="options.statuses">
                    <q-select chips multiple v-model="filters.status" :options="options.statuses" :float-label="$t('status')" clearable />
                </div>

            </div>
            <div class="row gutter-sm justify-end q-mt-sm">
                <div class="col-xs-12 col-sm-3">
                    <q-btn color="negative" class="full-width" :label="$t('clear_filters')" icon="far fa-eraser" @click="clearFilter()"/>
                </div>
                <div class="col-xs-12 col-sm-3">
                    <q-btn color="secondary" class="full-width" :label="$t('apply_filter_plural')" icon="far fa-filter" @click="requestFiltered()"/>
                </div>
            </div>
        </q-collapsible>
    </q-list>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    props: ['options'],
    data() {
        return {
            open: false,
            filters: {
                status: [],
                company_type: [],
            }
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            companies_filters: 'admin_filters/companies_filters'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getNameFilter() {
            if (Object.entries(this.filters).find((a) => a[1] && a[1].length > 0)) {
                return `${this.$t('filter')} <i class="far fa-exclamation-circle"></i>`
            } else return this.$t('filter')
        }
    },

    methods: {
        requestFiltered() {
            this.$emit('requestFiltered', {
                status: this.filters.status,
                company_type: this.filters.company_type,
            })
            this.saveCompaniesFilters()
            setTimeout(() => { this.toggle() }, 500)
        },

        clearFilter() {
            this.filters.status = []
            this.filters.company_type = []
            this.$emit('clearAndRequest')
            this.clearStoredFilters()
            setTimeout(() => { this.toggle() }, 500)
        },

        toggle() {
            this.open = !this.open
        },

        saveCompaniesFilters() {
            this.$store.dispatch('admin_filters/SET_COMPANIES_FILTERS', { companies_filters: this.filters })
        },

        loadCompaniesFilters() {
            this.filters = this.companies_filters
            setTimeout(() => {
                this.requestFiltered()
            }, 1000)
        },

        clearStoredFilters() {
            this.$store.dispatch('admin_filters/SET_COMPANIES_FILTERS', { companies_filters: {} })
        }
    },

    mounted () {
        if (this.companies_filters && this.companies_filters.status) {
            this.loadCompaniesFilters()
        }
    }
}
</script>

<style>

</style>
